import { StoreService } from '../shared/services/store-service.service';
import { SelectItem } from 'primeng/api';
import { CvDatabaseAccessTokenRequestStatus } from '../shared/models/cv-database-access-token-request-status';
import { CvDatabaseProductService } from '../shared/services/cv-database-product-service.service';
import { CvDatabaseAccessTokenRequestModel } from '../shared/models/cv-database-access-token-request-model';
import { StoreItemModel } from '../shared/models/store-item-model';
import { CvDatabaseAccessTokenRequestFilterModel } from '../shared/models/cv-database-access-token-request-filter-model';
import { Component, OnInit } from '@angular/core';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { LazyLoadEvent } from 'primeng/api';
import { LookupService } from '@admin/shared/services/lookup.service';
import { ConfigurationService } from '@admin/shared/services/configuration.service';
import { ProductType } from '@admin/product-purchases/shared/models/product-type';
import { UserService } from '../../core/user.service';
import { FeatureEnum } from '../../shared/models/feature-enum';
import { Table } from 'primeng/table';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cv-database-product-request-list',
  templateUrl: './cv-database-product-request-list.component.html',
  styleUrls: ['./cv-database-product-request-list.component.less'],
  standalone: false,
})
export class CvDatabaseProductRequestListComponent implements OnInit {
  public filterPagingWrapper: PagingFilter<CvDatabaseAccessTokenRequestFilterModel>;
  public storeItems: StoreItemModel[];

  public cvDatabaseAccessTokenRequestList: CvDatabaseAccessTokenRequestModel[];

  public totalRecords: number;

  public lastLoadEvent: LazyLoadEvent;

  public dateFormat: string;
  public specialDateFormat: string;
  public pageSize: number;

  private isReset: boolean;

  public switchFilterState: SwitchFilterState;
  public switchFilterStatEnum: any;

  public switchFilterStates: SelectItem[];

  public hasRequestApproveRejectPermission: boolean;
  public hasRequestTerminationPermission: boolean;

  public CvDatabaseAccessTokenRequestStatus: any;
  public ProductType: any;

  onLoad(event: LazyLoadEvent) {
    if (this.isReset) {
      this.cvDatabaseAccessTokenRequestList = [];
      this.totalRecords = 0;
      return;
    }

    this.filterPagingWrapper.pagingInfo.start = event.first;
    this.filterPagingWrapper.pagingInfo.limit = event.rows;
    this.lastLoadEvent = event;
    let filters: { [index: string]: any } = [];

    if (event.filters != null) {
      for (let f in event.filters) {
        {
          filters[f] = event.filters[f].value;
        }
      }
    }

    if (event.sortField && event.sortOrder) {
      this.filterPagingWrapper.sortParameters = [
        {
          column: event.sortField,
          order: event.sortOrder == 1 ? 'asc' : 'desc',
        },
      ];
    }

    this.filterPagingWrapper.filter.customerName = filters['fullName'];
    this.onFilter();
  }

  onFilter() {
    this.filterPagingWrapper.pagingInfo.start =
      this.filterPagingWrapper.pagingInfo.start || 0;

    this.filterPagingWrapper.filter.statusIds = [];

    let statusIds = this.getSwitchStateRelevantStatuses();

    this.filterPagingWrapper.filter.statusIds = statusIds;

    this.cvDatabaseProductService
      .listCvDatabaseAccessTokenRequests(this.filterPagingWrapper)
      .subscribe((d) => {
        this.totalRecords = d.totalCount;
        this.cvDatabaseAccessTokenRequestList = d.items;
      });
  }

  getSwitchStateRelevantStatuses() {
    let statusIds = [];

    switch (this.switchFilterState) {
      case SwitchFilterState.Pending: {
        statusIds.push(
          ...[
            CvDatabaseAccessTokenRequestStatus.Pending,
            CvDatabaseAccessTokenRequestStatus.DemoViewLimitReached,
          ]
        );
        break;
      }
      case SwitchFilterState.Active: {
        statusIds.push(
          ...[
            CvDatabaseAccessTokenRequestStatus.Approved,
            CvDatabaseAccessTokenRequestStatus.ViewLimitReached,
          ]
        );
        break;
      }
      case SwitchFilterState.Expired: {
        statusIds.push(...[CvDatabaseAccessTokenRequestStatus.Expired]);
        break;
      }
      case SwitchFilterState.Rejected: {
        statusIds.push(...[CvDatabaseAccessTokenRequestStatus.Rejected]);
        break;
      }
      case SwitchFilterState.Terminated: {
        statusIds.push(...[CvDatabaseAccessTokenRequestStatus.Terminated]);
        break;
      }
    }

    return statusIds;
  }

  //TODO: on select button change
  onSwitchFilterClick(dt: Table, newState: SwitchFilterState) {
    // this.filterPagingWrapper.filter.drivingLicenses = this.selectedDrivingLicenses.map(p => p.value);
    // this.filterPagingWrapper.filter.locations = this.selectedLocations.map(p => p.value);

    //set statusIds

    this.switchFilterState = newState;

    this.filterPagingWrapper.pagingInfo.start = 0;

    //TODO: bug in paginator, does not update state correctly, change this code after bug is fixed in framework (primeng)
    this.isReset = true;
    dt.reset();
    this.isReset = false;

    this.onFilter();
  }

  // getSpecialDateFormat(format: string){
  //     return format.replace('MM', 'mm').replace('yyyy', 'yy');
  // }

  onApproveRequestClick(item: CvDatabaseAccessTokenRequestModel) {
    if (!confirm(this.translateService.instant('message.AreYouSure'))) {
      return;
    }
    let token = item.issuedTokens[0];
    let productMofied = token.storeItem.itemId == token.storeItemId;
    if (!productMofied) {
      this.cvDatabaseProductService
        .approveCvDatabaseAccessTokenRequestWithModification(
          item,
          token.storeItemId
        )
        .subscribe((d) => {
          this.onFilter();
        });
    } else {
      this.cvDatabaseProductService
        .approveCvDatabaseAccessTokenRequest(item)
        .subscribe((d) => {
          this.onFilter();
        });
    }
  }

  onRejectRequestClick(item: CvDatabaseAccessTokenRequestModel) {
    if (!confirm(this.translateService.instant('message.AreYouSure'))) {
      return;
    }
    this.cvDatabaseProductService
      .rejectCvDatabaseAccessTokenRequest(item)
      .subscribe((d) => {
        this.onFilter();
      });
  }

  onRevokeRequestClick(result: any) {
    if (!result.agree) {
      return;
    }
    this.cvDatabaseProductService
      .revokeCvDatabaseAccessTokenRequest(result.id, result.checked)
      .subscribe((d) => {
        this.onFilter();
      });
  }

  constructor(
    private lookupService: LookupService,
    private config: ConfigurationService,
    private cvDatabaseProductService: CvDatabaseProductService,
    private userService: UserService,
    private storeService: StoreService,
    private translateService: TranslateService
  ) {
    this.hasRequestApproveRejectPermission = false;
    this.hasRequestTerminationPermission = false;

    this.filterPagingWrapper = new PagingFilter(
      new CvDatabaseAccessTokenRequestFilterModel()
    );
    this.CvDatabaseAccessTokenRequestStatus =
      CvDatabaseAccessTokenRequestStatus;
    this.ProductType = ProductType;
    this.cvDatabaseAccessTokenRequestList = [];
    this.switchFilterStates = [
      {
        label: this.translateService.instant('label.Pending'),
        value: SwitchFilterState.Pending,
      },
      {
        label: this.translateService.instant('label.Active'),
        value: SwitchFilterState.Active,
      },
      {
        label: this.translateService.instant('label.Expired'),
        value: SwitchFilterState.Expired,
      },
      {
        label: this.translateService.instant('label.Rejected'),
        value: SwitchFilterState.Rejected,
      },
      {
        label: this.translateService.instant('label.Terminated'),
        value: SwitchFilterState.Terminated,
      },
    ];
    this.switchFilterState = SwitchFilterState.Pending;
    this.switchFilterStatEnum = SwitchFilterState;
  }

  ngOnInit() {
    // let lookupData = this.lookupService.getCachedLookupData();

    let config = this.config.getCachedConfig();

    this.dateFormat = config.dateFormat; //TODO get from config
    //this.specialDateFormat = this.getSpecialDateFormat(this.dateFormat);
    this.pageSize = config.defaultPageSize; //TODO get from config

    const userFeatures = this.userService.currentUser.features;
    this.hasRequestApproveRejectPermission = userFeatures.some(
      (f) => f === FeatureEnum.ApproveRejectCvDbProductRequest
    );
    this.hasRequestTerminationPermission = userFeatures.some(
      (f) => f === FeatureEnum.TerminateActiveCvDbProduct
    );

    this.switchFilterState = SwitchFilterState.Pending;

    this.storeService
      .listStockItems(ProductType.CvDatabaseAccess)
      .subscribe((d) => {
        this.storeItems = d.items;
        // this.onFilter();
      });
  }
}

enum SwitchFilterState {
  Pending = 1,
  Active = 2,
  Expired = 3,
  Rejected = 4,
  Terminated = 5,
}
